import { Typography } from "@suraasa/placebo-ui"
import React, { useState } from "react"

const ImageWithErrorState = ({ src, alt }: { src: string; alt: string }) => {
  const [hasError, setHasError] = useState(false)

  if (hasError) {
    return (
      <div className="flex h-full min-h-[150px] flex-col items-center justify-center gap-2 rounded-md bg-surface-100 text-onSurface-300">
        <svg className="size-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
          <line
            x1="3"
            y1="3"
            x2="21"
            y2="21"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
        <Typography variant="smallBody" className="text-onSurface-400">
          Error loading image
        </Typography>
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className="size-full rounded-md object-cover"
      onError={() => setHasError(true)}
    />
  )
}

export default ImageWithErrorState
